export const is_point_type = (type) => {
    if (type === "Point" || type === "MultiPoint") return true;
    return false;
};